module.exports = __webpack_public_path__ + "static/images/save_active.svg";